// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KtnM","left":"styles_left__3sJLK","desktopActions":"styles_desktopActions__1V6Pk","title":"styles_title__18xlt"};